<section class="product-form-order-dialog">
	<div #productFormOrder class="product-form-order-container" *ngIf="!(isSuccess$ | async)">
		<section class="modal-header">
			<h3 *ngIf="formTitle">{{ formTitle }}</h3>
			<h3 *ngIf="!formTitle" i18n>Order product</h3>
			<g-icon
				[icon]="icons.faXmark"
				class="close-dialog"
				(click)="closeDialog()"
				role="button"
				i18n-title
				title="Close"
			/>
		</section>
		<section class="modal-body">
			<p class="info" [innerHTML]="formDescription"></p>
			<form id="product-order" [formGroup]="productFormOrderForm" (ngSubmit)="onSubmit()">
				<div class="form-group form-group-primary" fxLayout="row" fxLayout.xs="column">
					<div fxFlex="48" fxFlex.xs="100">
						<label for="firstName" class="is-required" i18n="@@AddressFirstNameLabel">First name</label>
						<input
							type="text"
							trim="blur"
							id="product-form-order-dialog-first-name"
							class="form-control form-control-primary"
							formControlName="firstName"
							autocomplete="given-name"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'firstName' }}
						</div>
					</div>
					<div fxFlex="4" fxFlex.xs="0"></div>
					<div fxFlex="48" fxFlex.xs="100">
						<label for="lastName" class="is-required" i18n="@@AddressLastNameLabel">Last name</label>
						<input
							type="text"
							trim="blur"
							id="product-form-order-dialog-last-name"
							class="form-control form-control-primary"
							formControlName="lastName"
							autocomplete="family-name"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'lastName' }}
						</div>
					</div>
				</div>

				<div class="form-group form-group-primary" fxLayout="row" fxLayout.xs="column">
					<div fxFlex="48" fxFlex.xs="100">
						<label for="email" class="is-required" i18n="@@AddressEmailLabel">Email</label>
						<input
							trim="blur"
							type="email"
							id="product-form-order-dialog-email"
							class="form-control form-control-primary"
							formControlName="email"
							autocomplete="work email"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'email' }}
						</div>
					</div>
					<div fxFlex="4" fxFlex.xs="0"></div>
					<div fxFlex="48" fxFlex.xs="100">
						<label for="phone" class="is-required" i18n="@@AddressPhoneLabel">Phone number</label>
						<input
							type="tel"
							trim="blur"
							id="product-form-order-dialog-phone"
							class="form-control form-control-primary"
							formControlName="phone"
							autocomplete="work tel"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'phone' }}
						</div>
					</div>
				</div>

				<div class="form-group form-group-primary" fxLayout="row" fxLayout.xs="column">
					<div fxFlex="100">
						<label for="streetName" class="is-required" i18n="@@AddressStreetNameLabel"
							>Street address</label
						>
						<input
							type="text"
							trim="blur"
							id="product-form-order-dialog-street-name"
							class="form-control form-control-primary"
							formControlName="streetName"
							autocomplete="street-address"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'streetName' }}
						</div>
					</div>
				</div>

				<div class="form-group form-group-primary" fxLayout="row" fxLayout.xs="column">
					<div fxFlex="48" fxFlex.xs="100">
						<label for="zipCode" class="is-required" i18n="@@AddressZipCodeLabel">Zip code</label>
						<input
							type="text"
							trim="blur"
							id="product-form-order-dialog-zip-code"
							class="form-control form-control-primary"
							formControlName="zipCode"
							autocomplete="postal-code"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'zipCode' }}
						</div>
					</div>
					<div fxFlex="4" fxFlex.xs="0"></div>
					<div fxFlex="48" fxFlex.xs="100">
						<label for="city" class="is-required" i18n="@@AddressCityLabel">City</label>
						<input
							type="text"
							trim="blur"
							id="product-form-order-dialog-city"
							class="form-control form-control-primary"
							formControlName="city"
							autocomplete="address-level2"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'city' }}
						</div>
					</div>
				</div>

				<div
					class="form-group form-group-primary"
					fxLayout="row"
					fxLayout.xs="column"
					*ngIf="isCompanyVisible"
				>
					<div fxFlex="48" fxFlex.xs="100">
						<label for="company" i18n="@@AddressCompanyLabel">Company</label>
						<input
							type="text"
							trim="blur"
							id="product-form-order-dialog-company"
							class="form-control form-control-primary"
							formControlName="company"
							autocomplete="organization"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'company' }}
						</div>
					</div>
				</div>

				<div class="button-container" fxLayout="row" fxLayoutAlign="center">
					<button
						type="submit"
						class="btn btn-primary"
						[disabled]="!productFormOrderForm.valid || isProcessing"
						[ngClass]="{ 'is-submitting': isProcessing }"
					>
						<span i18n>Send Request</span>
						<g-icon [icon]="icons.faSpinner" size="2x" pulse />
					</button>
				</div>
			</form>
		</section>
	</div>
	<div class="container product-form-order-container is-success" *ngIf="isSuccess$ | async">
		<h2 i18n>Thank you!</h2> <h3 i18n>Your message has been sent</h3>
		<div class="button-container" fxLayout="row" fxLayoutAlign="center">
			<button type="submit" class="btn btn-primary" i18n (click)="closeDialog()">Close</button>
		</div>
	</div>
</section>
